exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kiosk-team-register .free-trial-toggle .custom-control[data-v-7ea031ba] {\n  margin-left: 0px !important;\n  margin-top: 0px !important;\n}\n", ""]);

// exports
